/**Credentials of GCloud */
export const gcloudCredentials = {
  MAPS_API_KEY: "MAPS_KEY",
};

/**Google analytics ids */
export const GA_IDS = {
  TRACKING_GA4_ID: "G-ID",
};
